import _orderBy from 'lodash/orderBy';

export const state = {
  // for sorting items
  sortDefaultFolder: {
    loading: false,
    data: [],
  },
  sortCurrentChildFolder: {
    loading: false,
    data: [],
  } 
}


export const getters = {
}


export const mutations = {
  // SORTING FOLDER
  sortByFolder: (state, data) => {
    let selectedItems = data.items;
    let order = data.order;
    let key = data.key;
    let isMyFolderPage = data.isMyFolderPage;
    

    if(isMyFolderPage){
      state.sortDefaultFolder.data = selectedItems;

      state.sortDefaultFolder.data = _orderBy(selectedItems, key, order.toLowerCase());
    }
    else{
      state.sortCurrentChildFolder.data = selectedItems;

      state.sortCurrentChildFolder.data = _orderBy(selectedItems, key, order.toLowerCase());
    }
  }
}


export const actions = {
}